import React, { Component } from 'react';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { MessageBars } from '../Outils/MessageBars';
import { Icon } from 'office-ui-fabric-react/lib/Icon';

import { FicheContact } from './FicheContact/FicheContact';
import { FicheCommercialisateur } from './FicheCommercialisateur';
import { Timeline } from '../Timeline/Timeline';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';

import './FicheOption.css';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';
import { Data } from '../../data/Data.jsx';
import { DataCompte } from '../../data/DataCompte';
import { DataLotCommercial } from '../../data/DataLotCommercial.jsx';
import { DataMandat } from '../../data/DataMandat.jsx';
import { DataOption } from '../../data/DataOption.jsx';

/****************************************************************
 PROPS:
    idOperation
    idLotCommercial
    onAffichePanelOption : bool
    onFermeFicheOption: méthode
    idOption : int
****************************************************************/
const listeEtapes = [
    { numEtape: 1, icone: "FavoriteStar", nomEtape: "Options", onClick: null },
    { numEtape: 2, icone: "Contact", nomEtape: "Contact", onClick: null },
    { numEtape: 3, icone: "AccountManagement", nomEtape: "Commercialisateurs", onClick: null }
];

var objetState = {
    monCompte: null,
    idOperation: 0,
    idLotCommercial: 0,
    idContact: null,
    idOption: 0,
    titreOption: null,
    listOptions: [],
    listCommercialisateurs: [],
    //listDroits: {},
    peutCreer: false,
    peutAffecterDesCommercialisateurs: false,

    affichageOptions: true,
    affichagePanelContact: false,
    affichageCommercialisateurs: false,
    affichagePanelCommercialisateur: false,

    //AF - 18/12
    onPeutAjouterCommercialisateurs: true,
    onPeutSupprimerCommercialisateurs: true,

    onActiveBoutonTerminer: false,
    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',
    hideMessageBarWarning: true,
    warningMessage: '',
    hideMessageBarError: true,
    errorMessage: ''
};

export class FicheOption extends Component {
      _creationContent() {
        //let sectionAfficher = null;
        let numEtape = 0;

        let boutonCreation = (this.state.peutCreer ? <PrimaryButton name="ajouterOption" text="Ajouter une option" onClick={() => this._onAffichagePanelContact(null, 0)} /> : null);

        if (this.state.affichageOptions) {
            //sectionAfficher = this._creationSectionListeOptions();
            numEtape = 1;
        }
        else if (this.state.affichagePanelContact) {
            //sectionAfficher = this._creationSectionContact();
            numEtape = 2;
        }
        else if (this.state.affichageCommercialisateurs) {
            //sectionAfficher = this._creationSectionListeCommercialisateurs();
            numEtape = 3;
        }
        else if (this.state.affichagePanelCommercialisateur) {
            //sectionAfficher = this._creationSectionPanelCommercialisateur();
            numEtape = 3;
        }

        return (
            <Panel
                isOpen={this.props.onAffichePanelOption}
                headerText={this.state.titreOption}
                type={PanelType.extraLarge}
                onDismiss={() => this._onAnnulation()}
                onOpen={() => this._onOpen()}
                closeButtonAriaLabel="Fermer"
                onRenderFooterContent={this._onRenderFooterContent}
            >
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12">

                        <Timeline listeEtapes={listeEtapes} etapeActive={numEtape} />

                        <MessageBars
                            errorMessage={this.state.errorMessage}
                            warningMessage={this.state.warningMessage}
                            onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                            onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                        />

                        {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                    </div>


                    {(this.state.affichageOptions ?
                        <div>
                            <div className="ms-Grid-col ms-sm12">
                                {boutonCreation}
                            </div>
                            <div className="ms-Grid-col ms-sm12">
                                <DetailsList
                                    className="containerOption"
                                    items={this.state.listOptions}
                                    selectionMode={SelectionMode.none}
                                    columns={this.columnsOptions}
                                />
                            </div>
                        </div>
                        :
                        null)}


                    <FicheContact
                        idContact={this.state.idContact}
                        isOpen={this.state.affichagePanelContact}
                        onAnnuleFiche={() => this._onCachePanelContact()}
                        onEnregistrementFiche={(idContact) => this._chargementCommercialisateurs(idContact)}
                        //onRechargeFiche={(idContactSelectionne) => this._onRechargeFicheContact(idContactSelectionne)}
                        pasDAccesAuxSouhaits
                        pasDAccesAuxSouhaitsMaisonIndividuelle
                        pasDAccesAuxDenonciations
                        pasDAccesAHistorique
                        titre={`${this.state.titreOption} / ${(this.state.idContact == null ? "Ajouter un contact" : "Edition de contact")}`}
                        listeEtapesTimeline={listeEtapes}
                        numEtape={2}
                        appelDepuisOption

                    //onPeutChargerLeComposant={this.state.affichagePanelContact}

                    />

                    {(this.state.affichageCommercialisateurs ?
                        <div>
                            {(this.state.onPeutAjouterCommercialisateurs ?
                                <div className="ms-Grid-col ms-sm12">
                                    <PrimaryButton name="ajouterCommercialisateur" text="Ajouter un commercialisateur" onClick={() => this._onAffichagePanelCommercialisateur()} />
                                </div> :
                                null)}
                            <div className="ms-Grid-col ms-sm12">
                                <DetailsList
                                    className="containerOption"
                                    items={this.state.listCommercialisateurs}
                                    selectionMode={SelectionMode.none}
                                    columns={this.columnsCommercialisateurs}
                                />
                            </div>
                        </div> :
                        null)}

                    <FicheCommercialisateur
                        idOperation={this.state.idOperation}
                        idLotCommercial={this.state.idLotCommercial}
                        onAffichePanelCommercialisateur={this.state.affichagePanelCommercialisateur}
                        onAnnuleFiche={() => this._onCachePanelCommercialisateur()}
                        onEnregistrementFiche={(listCommercialisateur) => this._onCachePanelCommercialisateurEtAjoutDuCommercialisateur(listCommercialisateur)}
                        afficheHonorairesPerso={false}                        
                    />

                </div>
            </Panel>
        );
    }

    constructor(props) {
        super(props);

        this.state = objetState;

        //#region Chargement des columns des options
        let columnsTempOptions = [];

        columnsTempOptions.push({
            key: 'commercialisateur', name: 'Commercialisateur', fieldName: 'commercialisateur', minWidth: 200, maxWidth: 350,
            onRender: (item) => {
                return <span>{item.anonymisationNomSocieteLoginCompte}</span>;
            }
        });

        columnsTempOptions.push({
            key: 'contact', name: 'Contact', fieldName: 'contact', minWidth: 200, maxWidth: 350,
            onRender: (item) => {
                return <span>{item.anonymisationContactPrenomNom}</span>;
            }
        });

        columnsTempOptions.push({
            key: 'dateOption', name: 'Date option', fieldName: 'dateOption', minWidth: 100, maxWidth: 150,
            onRender: (item) => {
                return <span>{Scriba.date().stringDateHeureFormatCourt(item.date)}</span>;
            }
        });

        columnsTempOptions.push({
            key: 'dateLeveeOption', name: 'Date de levée', fieldName: 'dateLeveeOption', minWidth: 100, maxWidth: 150,
            onRender: (item) => {
                return <span>{Scriba.date().stringDateHeureFormatCourt(item.dateLevee)}</span>;
            }
        });

        columnsTempOptions.push({
            key: 'rang', name: 'Rang', fieldName: 'rang', minWidth: 50, maxWidth: 50,
            onRender: (item) => {
                return <span>{item.rang}</span>;
            }
        });

        columnsTempOptions.push({
            key: 'edition', name: '', fieldName: 'edition', minWidth: 25, maxWidth: 25,
            onRender: (item) => {
                let peutModifier = (item.modifier);
                if (peutModifier) {
                    return <Icon title="Modifier l'option" iconName="Edit" className="iconeEdition" onClick={() => this._onAffichagePanelContact(item.idContact, item.idOption)} />;
                }
                else {
                    return null;
                }
            }
        });

        columnsTempOptions.push({
            key: 'suppression', name: '', fieldName: 'suppression', minWidth: 25, maxWidth: 25,
            onRender: (item) => {
                let peutSupprimer = (item.supprimer);
                if (peutSupprimer) {
                    return <Icon name="supprimerOption" title="Supprimer l'option" iconName="Delete" className="iconeSuppression" onClick={() => this._suppressionOption(item.idOption)} />;
                }
                else {
                    return null;
                }
            }
        });

        this.columnsOptions = columnsTempOptions;
        //#endregion

        //#region Chargement des columns des commercialisateurs
        let columnsTempCommercialisateurs = [];

        columnsTempCommercialisateurs.push({
            key: 'societe', name: 'Société', fieldName: 'societe', minWidth: 200, maxWidth: 350,
            onRender: (item) => {
                return <span>{item.nomSociete}</span>;
            }
        });

        columnsTempCommercialisateurs.push({
            key: 'nom', name: 'Nom', fieldName: 'nom', minWidth: 200, maxWidth: 350,
            onRender: (item) => {
                return <span>{item.nomComplet}</span>;
            }
        });

        columnsTempCommercialisateurs.push({
            key: 'tel', name: 'Tel', fieldName: 'tel', minWidth: 100, maxWidth: 200,
            onRender: (item) => {
                return <span>{item.tel}</span>;
            }
        });

        columnsTempCommercialisateurs.push({
            key: 'honoraires', name: 'Honoraires', fieldName: 'honoraires', minWidth: 100, maxWidth: 200,
            onRender: (item) => {
                return <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.honoraireReelNombre, false, 2)} €</span>;
            }
        });

        columnsTempCommercialisateurs.push({
            key: 'login', name: 'Login', fieldName: 'login', minWidth: 200, maxWidth: 350,
            onRender: (item) => {
                return <span>{item.loginCompte}</span>;
            }
        });

        columnsTempCommercialisateurs.push({
            key: 'suppression', name: '', fieldName: 'suppression', minWidth: 25, maxWidth: 25,
            onRender: (item) => {
                let bouton = null;

                if (this.state.onPeutSupprimerCommercialisateurs) {
                    bouton = <Icon title="Supprimer le commercialisateur" iconName="Delete" className="iconeSuppression" onClick={() => this._suppressionCommercialisateur(item)} />;
                }

                return bouton;
            }
        });

        this.columnsCommercialisateurs = columnsTempCommercialisateurs;
        //#endregion
    }

    _onInit() {
        this.setState(objetState);
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onFermeFicheOption();
    }

    _onAffichagePanelContact = (idContact, idOption) => {

        this.setState({
            affichageOptions: false,
            affichagePanelContact: true,
            affichageCommercialisateurs: false,
            affichagePanelCommercialisateur: false,
            idContact: idContact,
            idOption: idOption
        });

        //AF - 19/12/2019 - On pré-calcule au chargement les honoraires et on charge la liste des commercialisateurs en async. 
        //2 cas possibles:
        //- profil connecté est COMMERCIALISATEUR et en CREATION
        //- profil connecté n'est PAS COMMERCIALISATEUR et en MODIFICATION
        //L'IdOption ne peut etre récupéré qu'a partir de cette étape. Le code ne peut pas etre regroupé ailleurs.
        this._onChargementDeLaListeDesCommercialisateurs(idOption);
    }

    _onChargementDeLaListeDesCommercialisateurs(idOption) {
        if (!this.state.peutAffecterDesCommercialisateurs) {
            let listeDesPromisesAExecuter = [];

            let chargementMandatCommercialisateurLePlusBasPourUnLotCommercial = DataMandat._chargementMandatCommercialisateurLePlusBasPourUnLotCommercial(this.props.idOperation, this.props.idLotCommercial, this.state.monCompte.compteTrav.loginCompte);
            let chargementLotCommercial = DataLotCommercial._chargementLotCommercial(this.props.idOperation, this.props.idLotCommercial);

            listeDesPromisesAExecuter.push(chargementMandatCommercialisateurLePlusBasPourUnLotCommercial);
            listeDesPromisesAExecuter.push(chargementLotCommercial);

            Promise.all(listeDesPromisesAExecuter)
                .then(responsePromise => {
                    //*******************************************************************
                    //déclaration des variables
                    let chargementMandatCommercialisateurLePlusBasPourUnLotCommercialJSON = responsePromise[0];
                    let chargementLotCommercialJSON = responsePromise[1];
                    //*******************************************************************   

                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responsePromise, this);

                    if (retourVerif === null) {
                        let mandat = chargementMandatCommercialisateurLePlusBasPourUnLotCommercialJSON.reponseAPIobjet;
                        let lotcommercial = chargementLotCommercialJSON.reponseAPIobjet[1];
                        let tvaOperation = chargementLotCommercialJSON.reponseAPIobjet[2];

                        if (tvaOperation !== undefined) {
                            let honorairesCalcules = this._onCalulDesHonoraires(mandat, tvaOperation, lotcommercial);
                            
                            let stateTemp = {};
                            stateTemp.listCommercialisateurs = [{
                                loginCompte: this.state.monCompte.compteTrav.loginCompte,
                                idSociete: this.state.monCompte.saSociete.idSociete,
                                nomSociete: this.state.monCompte.saSociete.nom,
                                nomComplet: this.state.monCompte.compteTrav.nom + ' ' + this.state.monCompte.compteTrav.prenom,
                                tel: this.state.monCompte.compteTrav.tel,
                                honoraireReelHT: honorairesCalcules
                            }];
                            stateTemp.onPeutAjouterCommercialisateurs = false;
                            stateTemp.onPeutSupprimerCommercialisateurs = false;

                            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                        }
                        else {
                            this.setState({
                                enCoursDeTraitement: false,
                                messageEnCoursTraitement: '',
                                hideMessageBarWarning: false,
                                warningMessage: 'Impossible de créer une option : aucune TVA renseignée pour cette opération'
                            });
                        }
                    }
                    else {
                        Immocom.onTraitementErreurPromise(this, retourVerif)
                    }
                });
        }
        else {
            if (this.state.idOperation !== 0 && this.state.idLotCommercial !== 0 && idOption !== 0) {
                let chargementFicheOption_Commercialisateurs = DataOption._chargementFicheOption_Commercialisateurs(this.state.idOperation, this.state.idLotCommercial, idOption);

                chargementFicheOption_Commercialisateurs
                    .then(responseFetch => {
                        let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                        if (retourVerif === null) {
                            let objetData = responseFetch.reponseAPIobjet;

                            let monCompte = objetData[0];
                            let mandat = objetData[1]
                            let tvaOperation = objetData[2];
                            let lotcommercial = objetData[3];

                            if (tvaOperation[0] !== undefined) {
                                let honorairesCalcules = this._onCalulDesHonoraires(mandat, tvaOperation, lotcommercial);
                                
                                let stateTemp = {};
                                stateTemp.listCommercialisateurs = [{
                                    loginCompte: monCompte.compteTrav.loginCompte,
                                    idSociete: monCompte.saSociete.idSociete,
                                    nomSociete: monCompte.saSociete.nom,
                                    nomComplet: monCompte.compteTrav.nom + ' ' + monCompte.compteTrav.prenom,
                                    tel: monCompte.compteTrav.tel,
                                    honoraireReelHT: honorairesCalcules
                                }];
                                
                                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                            }
                            else {
                                this.setState({
                                    enCoursDeTraitement: false,
                                    messageEnCoursTraitement: '',
                                    hideMessageBarWarning: false,
                                    warningMessage: 'Impossible de créer une option : aucune TVA renseignée pour cette opération'
                                });
                            }
                        }
                        else {
                            Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                        }
                    });
            }
        }
    }

    _onCachePanelContact = () => {
        //ajout de ce test car lorsqu'on appuie sur le bouton Enregistrer de la FicheContact on appelle la méthode '_chargementCommercialisateurs'
        //et ça c'est bon par contre on rentre aussi ds la méthode '_onVerificationSiDenonciationExiste'
        //et est appelée alors la méthode 'this._onFermetureFormulaire()' qui elle appelle la méthode 'onAnnuleFiche' 
        //et cette méthjode réinitalise les bool d'affichage et réaffiche l'option au lieu de basculer sur les commercialisateurs
        if (!this.state.affichageCommercialisateurs & this.state.listCommercialisateurs.length == 0) {
            this.setState({
                affichageOptions: true,
                affichagePanelContact: false,
                affichageCommercialisateurs: false,
                affichagePanelCommercialisateur: false,
                idContact: 0,
                idOption: 0
            });
        }
        else if (!this.state.affichageCommercialisateurs) {
            this.setState({
                affichageOptions: true,
                affichagePanelContact: false,
                affichageCommercialisateurs: false,
                affichagePanelCommercialisateur: false,
                idOption: 0
            });
        }
    };

    _onAffichagePanelCommercialisateur = () => {
        if (this.state.listCommercialisateurs.length > 0) {
            alert("Il existe déjà un commercialisateur pour cette option");
        }
        else {
            this.setState({
                affichageOptions: false,
                affichagePanelContact: false,
                affichageCommercialisateurs: false,
                affichagePanelCommercialisateur: true
            });
        }
    }

    _onCachePanelCommercialisateur = () => {
        this.setState({
            affichageOptions: false,
            affichagePanelContact: false,
            affichageCommercialisateurs: true,
            affichagePanelCommercialisateur: false
        });
    };

    _onCachePanelCommercialisateurEtAjoutDuCommercialisateur = (listCommercialisateur) => {
        //MG - 2335/2239
        let listCommercialisateursTrav = [];

        if (this.props.idReservation === 0 || this.props.idReservation == null) {
            listCommercialisateursTrav = [...this.state.listCommercialisateurs];
            let commercialisateur = listCommercialisateur[0];

            // On vérifie qu'il n'est pas déjà dans la liste
            if (listCommercialisateursTrav.length === 0) {
                listCommercialisateursTrav.push(commercialisateur);
            }
            else {
                listCommercialisateursTrav = listCommercialisateursTrav.filter(e => e.loginCompte !== commercialisateur.loginCompte);
                listCommercialisateursTrav.push(commercialisateur);
            }
        }

        this.setState({
            affichageOptions: false,
            affichagePanelContact: false,
            affichageCommercialisateurs: true,
            affichagePanelCommercialisateur: false,
            listCommercialisateurs: listCommercialisateursTrav
        });

        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, this.state);
    };

    //_onRechargeFicheContact = (idContactSelectionne) => {
    //    this.setState({
    //        affichageOptions: false,
    //        affichagePanelContact: true,
    //        affichageCommercialisateurs: false,
    //        affichagePanelCommercialisateur: false,
    //        idContact: idContactSelectionne
    //    });
    //}

    _chargementDonnees(onForceLeRechargement) {
        let idOperationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idOperation, [0, this.state.idOperation]);
        let idLotCommercialRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idLotCommercial, [0, this.state.idLotCommercial]);

        //let propsIdOperationRenseignee = Immocom.getSiPropsRenseignee(this.props.idOperation);
        //let propsIdLotCommercialRenseignee = Immocom.getSiPropsRenseignee(this.props.idLotCommercial);
        //let propsIdOperationDifferentDeStateIdOperation = (this.props.idOperation !== this.state.idOperation);
        //let propsIdLotCommercialDifferentDeStateIdLotCommercial = (this.props.idLotCommercial !== this.state.idLotCommercial);

        //if ((propsIdOperationRenseignee && propsIdLotCommercialRenseignee && propsIdOperationDifferentDeStateIdOperation && propsIdLotCommercialDifferentDeStateIdLotCommercial) || (onForceLeRechargement)) {
        if (this.state.affichageOptions && ((idOperationRenseigneeEtDifferent && idLotCommercialRenseigneeEtDifferent) || (onForceLeRechargement))) {

            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement des options'
            });
            let listeDesPromisesAExecuter = [];

            let chargementFicheOption = DataOption._chargementFicheOption(this.props.idOperation, this.props.idLotCommercial);
            let chargementMonCompte = DataCompte._chargementMonCompte();
            let chargementTitreOption = DataOption._chargementTitreOption(this.props.idOperation, this.props.idLotCommercial);

            listeDesPromisesAExecuter.push(chargementFicheOption);
            listeDesPromisesAExecuter.push(chargementMonCompte);
            listeDesPromisesAExecuter.push(chargementTitreOption);

            Promise.all(listeDesPromisesAExecuter)
                .then(responsePromise => {
                    //*******************************************************************
                    //déclaration des variables
                    let chargementFicheOptionJSON = responsePromise[0];
                    let chargementMonCompteJSON = responsePromise[1];
                    let chargementTitreOptionJSON = responsePromise[2];
                    //*******************************************************************

                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responsePromise, this);

                    if (retourVerif === null) {
                        let titre = this._onGetTitre(chargementTitreOptionJSON);

                        let stateTemp = {};
                        stateTemp.idLotCommercial = this.props.idLotCommercial;
                        stateTemp.idOperation = this.props.idOperation;
                        stateTemp.monCompte = chargementMonCompteJSON.reponseAPIobjet;
                        stateTemp.titreOption = 'Option / ' + titre;
                        stateTemp.listOptions = chargementFicheOptionJSON.reponseAPIobjet[0];
                        stateTemp.listCommercialisateurs = [];
                        stateTemp.peutCreer = chargementFicheOptionJSON.reponseAPIobjet[1];
                        stateTemp.peutAffecterDesCommercialisateurs = chargementFicheOptionJSON.reponseAPIobjet[2];
                        stateTemp.affichageOptions = true;
                        stateTemp.affichagePanelContact = false;
                        stateTemp.affichageCommercialisateurs = false;
                        stateTemp.affichagePanelCommercialisateur = false;
                        stateTemp.onActiveBoutonTerminer = false;
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                    }
                    else {
                        Immocom.onTraitementErreurPromise(this, retourVerif)
                    }
                });
        }
    }

    _chargementTitreOption() {
        let idOperation = this.props.idOperation;
        let idLotCommercial = this.props.idLotCommercial;

        if (idOperation !== 0 && idLotCommercial !== 0) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement du titre de l\'option'
            });

            let chargementTitreOption = DataOption._chargementTitreOption(idOperation, idLotCommercial);

            chargementTitreOption
                .then(responseFetch => {

                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let titre = this._onGetTitre(responseFetch);

                        let stateTemp = {};
                        stateTemp.titreOption = 'Option / ' + titre;
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
    }

    _chargementCommercialisateurs(idContact) {
        //AF - 18/12 - On passe par cette étape dans tous les cas.
        this.setState({
            affichageOptions: false,
            affichagePanelContact: false,
            affichageCommercialisateurs: true,
            affichagePanelCommercialisateur: false,
            onActiveBoutonTerminer: true,
            idContact: idContact
        });
    }

    _onCalulDesHonoraires(mandat, tvaOperation, lotcommercial) {
        let prixHT = lotcommercial.prixHT;
        let tvaLot = tvaOperation.taux;
        let prixTTCLot = prixHT * (1 + tvaLot);
        let honorairesCalcules = 0;

        if (mandat.honoraireCommercialisation !== undefined && mandat.honoraireCommercialisation != null) {

            const result = Immocom.calculationHonoraireReel(mandat.honoraireCommercialisation, mandat.baseCalculHonoraireCommercialisation, prixTTCLot, prixHT);
            honorairesCalcules = result !== undefined ? result.honoraireReel.toFixed(2) : 0;

            return honorairesCalcules;
        }
    }

    _chargementMonCompte() {
        let chargementMonCompte = DataCompte._chargementMonCompte();

        chargementMonCompte
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let stateTemp = {};
                    stateTemp.monCompte = responseFetch.reponseAPIobjet;
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onGetTitre(responseFetch) {
        let objetData = null;
        let titre = null;

        if (responseFetch.reponseAPIobjet.length > 0) {
            objetData = responseFetch.reponseAPIobjet[0];
            titre = objetData.nomCommercial + " - " + objetData.nature + " " + objetData.lotType + " N° " + objetData.numero + " - " + Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(objetData.surfaceHabitable.toFixed(2), false, 2) + " m² - " + Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(objetData.prixTTC.toFixed(2), false, 2) + " €";
        }
        else {
            objetData = responseFetch.reponseAPIobjet;
            titre = objetData.numero
        }

        return titre;
    }

    _enregistrementOption() {
        this.setState({ enCoursDeTraitement: true, messageEnCoursTraitement: 'Enregistrement de l\'option' });

        var enregistrementOption = DataOption._onEnregistrementOption(this.state.idOption, this.state.idOperation, this.state.idLotCommercial, this.state.idContact, this.state.listCommercialisateurs[0].loginCompte);

        enregistrementOption
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    this.props.onFermeFicheOption();
                }
                else {
                    let stateTemp = {};
                    stateTemp.listCommercialisateurs = [];
                    stateTemp.affichageOptions = true;
                    stateTemp.affichagePanelContact = false;
                    stateTemp.affichageCommercialisateurs = false;
                    stateTemp.affichagePanelCommercialisateur = false;
                    stateTemp.onActiveBoutonTerminer = false;

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    _suppressionOption(idOption) {
        if (window.confirm("Etes-vous certain de vouloir supprimer cette option ?")) {
            if (idOption !== 0) {
                this.setState({ enCoursDeTraitement: true, messageEnCoursTraitement: 'Suppression de l\'option' });

                var suppressionOption = DataOption._onSuppressionOption(idOption);

                suppressionOption
                    .then(responseFetch => {
                        let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                        if (retourVerif === null) {
                            this._chargementDonnees(true);
                        }
                        else {
                            let stateTemp = {};
                            stateTemp.affichageOptions = true;
                            stateTemp.affichagePanelContact = false;
                            stateTemp.affichageCommercialisateurs = false;
                            stateTemp.affichagePanelCommercialisateur = false;

                            Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                        }
                    });
            }
        }
    }

    _suppressionCommercialisateur(commercialisateur) {
        if (window.confirm("Etes-vous certain de vouloir supprimer ce commercialisateur ?")) {
            let tableauCommercialisateurs = this.state.listCommercialisateurs;
            let element = tableauCommercialisateurs.find(c => c.loginCompte === commercialisateur.loginCompte);
            let index = tableauCommercialisateurs.indexOf(element);

            this.setState({ listCommercialisateurs: tableauCommercialisateurs.slice((index + 1), 2) });
        }
    }

    _onRenderFooterContent = () => {
        return (
            <div>
                <PrimaryButton name="buttonTerminerOption" onClick={() => this._enregistrementOption()} className="marginRight8px" disabled={!this.state.onActiveBoutonTerminer || this.state.listCommercialisateurs.length <= 0}>Terminer</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Quitter</DefaultButton>
            </div>
        );
    };

    _onOpen = () => {
        this._chargementDonnees();
    }

    componentDidMount() {
    }

    componentDidUpdate() {
    }

    render() {
        return this._creationContent();
    }
}
